import { render, staticRenderFns } from "./MetricsOverviewModal.vue?vue&type=template&id=07d2d788&scoped=true&"
import script from "./MetricsOverviewModal.vue?vue&type=script&lang=js&"
export * from "./MetricsOverviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d2d788",
  null
  
)

export default component.exports